import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import HeaderComponent from "./processComponent/HeaderComponent";
import axios from "axios";
import { getGlobals } from "../../Configs";
import { useSelector } from "react-redux";
import moment from "moment";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import CycleCountCountingDetailModal from "./processComponent/CycleCountCountingDetailModal";

const CycleCountCounting = () => {
  const uMediaQuery = useMediaQuery("(max-width:400px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:900px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [countingSummary, setCountingSummary] = useState([]);
  // const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );

  const [filterState, setFilterState] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
      1,
      0,
      0
    ),
    dateTo: new Date(),
    location: LocWithRights.length > 0 ? LocWithRights[0].Uid : [],
    status: "All",
  });

  const status = ["All", "Enter", "Post"];
  const baseURL = getGlobals().API_BASE_URL;

  useEffect(() => {}, [filterState]);
  const handleRowClick = (params) => {
    setSelectedRow(params.row); // Store full row data
    setOpen(true);

    setTimeout(() => {
      document.getElementsByName("Barcode")[0]?.focus();
    }, 100);
  };
  const fFilter = () => {
    setOpenFilterModal(true);
  };
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  // Columns for the DataGrid
  const columns = [
    {
      field: "A_SheetId",
      headerName: "Sheet.ID",
      width: xMediaQuery ? 60 : 80,
    },
    {
      field: "A_Date",
      headerName: "Date",
      width: 95,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "A_RefNo",
      headerName: "Ref.No",
      width: xMediaQuery ? 80 : 100,
      hide: true,
    },
    {
      field: "Loc_Name",
      headerName: "Location",
      width: aMediaQuery ? 150 : 0,
      flex: aMediaQuery ? 0 : 1,
    },
    {
      field: "UserName",
      headerName: "User Name",
      width: xMediaQuery ? 200 : 250,
    },
    {
      field: "A_CountStatus",
      headerName: "Status",
      width: xMediaQuery ? 80 : 100,
    },
    { field: "A_Status", headerName: "Status", fles: 0.6, hide: true },
    {
      field: "A_VarianceStatus",
      headerName: "Variance",
      width: xMediaQuery ? 80 : 100,
    },
    {
      field: "A_FinalPosted",
      headerName: "Adjustment",
      width: xMediaQuery ? 80 : 100,
    },
    {
      field: "A_Narration",
      headerName: "Narration",
      width: aMediaQuery ? 150 : 0,
      flex: aMediaQuery ? 0 : 1,
      hide: aMediaQuery ? true : false,
    },
  ];

  const handleLoadBtn = () => {
    getCountingSummary();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const getCountingSummary = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/physicalStockSummary`,
        fcheck_null_undefine_replace_empty({
          P_FromDate: moment(filterState.dateFrom).format("MM/DD/YYYY"),

          P_ToDate: moment(filterState.dateTo).format("MM/DD/YYYY"),

          P_Location: filterState.location,

          P_A_CountStatus: filterState?.status,
          P_UserCd: vRdxuserInfo?.UserID,
        })
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        setCountingSummary(response?.data?.recordset);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };

  useEffect(() => {
    getCountingSummary();
  }, []);

  return (
    <div className="div-container">
      <Box pt={2}>
        {/* Title */}
        {vMediaQuery ? (
          <Grid container>
            <Grid
              item
              xs={9.6}
              sm={7}
              md={11}
              marginTop={uMediaQuery ? 0.5 : 0}
            >
              <Typography
                variant="h6"
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600 }}
              >
                Physical Stock Counting
              </Typography>
            </Grid>
            <Grid item xs={1} sm={2.5} md={1} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Physical Stock Counting
            </Typography>

            <HeaderComponent
              closeModal={() => setOpenFilterModal(false)}
              status={status}
              vMediaQuery={vMediaQuery}
              handleLoadBtn={handleLoadBtn}
              setFilterState={setFilterState}
              filterState={filterState}
              vRdxDBLocation={LocWithRights}
            />
          </>
        )}

        {/* DataGrid Section */}
        <Box
          sx={{
            height: vMediaQuery ? "80vh" : xMediaQuery ? "65vh" : "72vh",
            width: "100%",
            mt: vMediaQuery ? 4 : 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            components={{
              Toolbar: GridToolbar,
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
               '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            rows={countingSummary ? countingSummary : ""}
            getRowId={(v) => v.A_SheetId}
            columns={columns}
            onRowClick={handleRowClick}
          />
        </Box>
        <CycleCustomModal
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="Filter"
        >
          <HeaderComponent
            closeModal={() => setOpenFilterModal(false)}
            status={status}
            vMediaQuery={vMediaQuery}
            setFilterState={setFilterState}
            filterState={filterState}
            vRdxDBLocation={LocWithRights}
            handleLoadBtn={handleLoadBtn}
          />
        </CycleCustomModal>

        <CycleCustomModal
          open={open}
          onClose={() => {
            setOpen(false);
            getCountingSummary();
          }}
          vMediaQuery={vMediaQuery}
          xMediaQuery={xMediaQuery}
          title="CyclicCounting Detail"
        >
          <CycleCountCountingDetailModal
            open={open}
            closeModal={() => {
              setOpen(false);
              getCountingSummary();
            }}
            vMediaQuery={vMediaQuery}
            xMediaQuery={xMediaQuery}
            rowData={selectedRow}
          />
        </CycleCustomModal>
      </Box>
    </div>
  );
};

export default CycleCountCounting;
